import { colorConstants } from 'config/colorConstants';
import dayjs from 'dayjs';
import _ from 'lodash';
import { getPercentageChangeV2 } from 'utils/helperMethods';

export const salesTrendChartParser = (data: any[], appConfig: any) => {
    try {
        const lineChartResult: any = { minVal: 0, maxVal: 0, data: [] };
        const barChartResult: any = { minVal: 0, maxVal: 0, data: [] };
        data.forEach((item: any, index: number) => {
            const percentageChange =
                item.attributionValue && item.salesPrevious
                    ? _.round((item.attributionValue / item.salesPrevious) * 100, 2)
                    : 0;
            lineChartResult.minVal = Math.min(lineChartResult?.minVal, item?.salesCurrent, item?.salesPrevious);
            lineChartResult.maxVal = Math.max(lineChartResult?.maxVal, item?.salesCurrent, item?.salesPrevious);
            barChartResult.minVal = Math.min(barChartResult?.minVal, percentageChange);
            barChartResult.maxVal = Math.max(barChartResult?.maxVal, percentageChange);
            const lineChartTempObj = {
                period: dayjs(item?.startTimestamp).format(appConfig?.commonConfig?.dateFormatAlt),
                // period: item?.periodLabel,
                'Current Year': item?.salesCurrent,
                'Year Ago': item?.salesPrevious,
            };

            const barChartTempObj = {
                category: dayjs(item?.startTimestamp).format(appConfig?.commonConfig?.dateFormatAlt),
                // category: item?.periodLabel,
                sales: percentageChange,
                color: percentageChange >= 0 ? colorConstants.limeGreen : colorConstants.red,
            };
            lineChartResult?.data?.push(lineChartTempObj);
            barChartResult?.data?.push(barChartTempObj);
        });
        return { lineChartResult, barChartResult };
    } catch (error) {
        throw error;
    }
};
